import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export interface IIntegrationUserMapPatch {
	providerId: string;
	userId: string | null;
}

export const usePatchExternalIntegrationUserMapsMutation = ({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (updated: Api.IIntegrationUser[]) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			integrationProvider,
			patches,
			skipLoad,
		}: {
			integrationProvider: Api.IntegrationProvider;
			patches: IIntegrationUserMapPatch[];
			/** Set when restartAfterSave follows, so the server's own Load can't race the restart's full sync */
			skipLoad?: boolean;
		}) =>
			userSession.webServiceHelper.callAsync<Api.IIntegrationUser[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations/${integrationProvider}/userMaps`,
					queryParams: skipLoad ? { skipLoad } : undefined,
				}),
				'PATCH',
				patches
			),
		onError,
		onSuccess,
	});
};
